
var snippets = function(){

	var container = $('.edit.snippet, .create.snippet');

	/**
	 * [wysiwyg description]
	 * @return {[type]} [description]
	 */
	this.wysiwyg = function()
	{
		$('.redactor').redactor({
			minHeight : 300,
			toolbarFixed : false,
			cleanStyleOnEnter : true,
			deniedTags : ['html', 'head', 'link', 'body', 'meta', 'script', 'style', 'applet', 'span'],
			plugins : [ 'mediaManager' ]
		});
	};

};

jQuery(document).ready( function($){

	if( $('.create.snippet, .edit.snippet').length ) {
		var app = new snippets();
		app.wysiwyg();
	}

});